import { IConditionalNode } from '../../../helpers/conditional-nodes.helpers';
import { ProductID } from '../../../models/product.model';
import {
  CelluloseFibre,
  Wool,
  HempFibre,
  InsulationProducts,
  InsulationPropertyName,
  InsulationSpecialPropertyName,
  StoneWool,
  WoodFibre,
  InsulationMaterial,
} from './insulation.model';

export const celluloseFibreConditionalProducts: IConditionalNode<InsulationProducts> =
  {
    property: InsulationPropertyName.form,
    map: {
      [CelluloseFibre.Batts]: InsulationProducts.CelluloseFibreBatts,

      [CelluloseFibre.BlowingWoolPostConsumerPaper]:
        InsulationProducts.CelluloseFibreBlowingWoolPostConsumerPaper,

      [CelluloseFibre.BlowingWoolPrimaryRawMaterial]:
        InsulationProducts.CelluloseFibreBlowingWoolPrimaryRawMaterial,

      [CelluloseFibre.BlowingWoolRecycledPrimaryPaper]:
        InsulationProducts.CelluloseFibreBlowingWoolRecycledPrimaryPaper,
    },
  };

export const hempFibreConditionalProducts: IConditionalNode<InsulationProducts> =
  {
    property: InsulationPropertyName.form,
    map: {
      [HempFibre.Polyester]: InsulationProducts.HempFibrePolyester,
      [HempFibre.Polylactic]: InsulationProducts.HempFibrePolylactic,
    },
  };

const soundBattsConditionalProducts: IConditionalNode<InsulationProducts> = {
  property: InsulationSpecialPropertyName.SoundBatts,
  map: {
    true: InsulationProducts.GlassWoolBattsAndRollsSoundBatts,
    false: InsulationProducts.GlassWoolBattsAndRollsGeneral,
  },
};

export const glassWoolConditionalProducts: IConditionalNode<InsulationProducts> =
  {
    property: InsulationPropertyName.form,
    map: {
      [Wool.BattsAndRolls]: soundBattsConditionalProducts,

      [Wool.BlowingWoolAtticFloor]:
        InsulationProducts.GlassWoolBlowingWoolAtticFloor,

      [Wool.BlowingWoolFlooring]:
        InsulationProducts.GlassWoolBlowingWoolFlooring,

      [Wool.BlowingWoolWall]: InsulationProducts.GlassWoolBlowingWoolWall,
      [Wool.FacadeBoard]: InsulationProducts.GlassWoolFacadeBoard,
    },
  };

export const stoneWoolConditionalProducts: IConditionalNode<InsulationProducts> =
  {
    property: InsulationPropertyName.form,
    map: {
      [Wool.BattsAndRolls]: InsulationProducts.StoneWoolBattsAndRolls,

      [Wool.BlowingWoolAtticFloor]:
        InsulationProducts.StoneWoolBlowingWoolAtticFloor,

      [Wool.BlowingWoolFlooring]:
        InsulationProducts.StoneWoolBlowingWoolFlooring,

      [Wool.BlowingWoolWall]: InsulationProducts.StoneWoolBlowingWoolWall,
      [Wool.FacadeBoard]: InsulationProducts.StoneWoolFacadeBoard,
      [StoneWool.GroundBoard]: InsulationProducts.StoneWoolGroundBoard,
      [StoneWool.PlasterBoard]: InsulationProducts.StoneWoolPlasterBoard,
      [StoneWool.RoofBoard]: InsulationProducts.StoneWoolRoofBoard,
    },
  };

export const woodFibreConditionalProducts: IConditionalNode<InsulationProducts> =
  {
    property: InsulationPropertyName.form,
    map: {
      [WoodFibre.Batts]: InsulationProducts.WoodFibreBatts,
      [WoodFibre.BlowingWool]: InsulationProducts.WoodFibreBlowingWool,
    },
  };
export const insulationProductIds: IConditionalNode<ProductID> = {
  property: InsulationPropertyName.material,
  map: {
    [InsulationMaterial.CelluloseFibre]: [celluloseFibreConditionalProducts],
    [InsulationMaterial.HempFibre]: [hempFibreConditionalProducts],
    [InsulationMaterial.Hempcrete]: InsulationProducts.Hempcrete,
    [InsulationMaterial.GlassWool]: [glassWoolConditionalProducts],
    [InsulationMaterial.StoneWool]: [stoneWoolConditionalProducts],
    [InsulationMaterial.Phenolic]: InsulationProducts.Phenolic,
    [InsulationMaterial.WoodFibre]: [woodFibreConditionalProducts],
    [InsulationMaterial.EPS]: InsulationProducts.EPS,
    [InsulationMaterial.XPS]: InsulationProducts.XPS,
  },
};
